import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function Stats() {
  const [card1Ref, card1Visible] = useScrollAnimation();
  const [card2Ref, card2Visible] = useScrollAnimation();
  const [card3Ref, card3Visible] = useScrollAnimation();
  const { t } = useTranslation();

  return (
    <div className="stats-wrapper">
      <div className="stats container">
        <div
          ref={card1Ref}
          className={`stats-card ${card1Visible ? "animate-in" : ""}`}
        >
          <h2 className="fs-1000">1963</h2>
          <h3 className="fs-600">{t("stats.companyFounded")}</h3>
          <p className="fs-400">{t("stats.companyFoundedDesc")}</p>
        </div>
        <div
          ref={card2Ref}
          className={`stats-card ${card2Visible ? "animate-in" : ""}`}
        >
          <h2 className="fs-1000">2010</h2>
          <h3 className="fs-600">{t("stats.majorExpansion")}</h3>
          <p className="fs-400">{t("stats.majorExpansionDesc")}</p>
        </div>
        <div
          ref={card3Ref}
          className={`stats-card ${card3Visible ? "animate-in" : ""}`}
        >
          <h2 className="fs-1000">2025</h2>
          <h3 className="fs-600">{t("stats.industryLeadership")}</h3>
          <p className="fs-400">{t("stats.industryLeadershipDesc")}</p>
        </div>
      </div>
    </div>
  );
}

export default Stats;
